<template>
  <SysDialog v-model="DIALOG_ATIVO_COMPUTED">
    <template #titulo>
      <div>
        <p class="ma-0 font-20 font-weight-medium">Exportação para o ERP</p>
        <p class="ma-0 mt-n3 font-13 font-weight-regular text-gray-1100">
          Exportação do pedido #{{ pedido.idpedido }} com {{ produtos_pedido.length }} produto{{ produtos_pedido.length > 1 ? 's' : ''}}
        </p>
      </div>

      <v-spacer />

      <v-btn
        icon
        @click="DIALOG_ATIVO_COMPUTED = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <div v-if="DIALOG_ATIVO_COMPUTED" class="pb-2">
      <div>
        <SysFilialGrupoAutocomplete
          v-model="exportacao.codigo_filial"
          label="Filial"
          outlined
          hide-details
        />
      </div>

      <div class="mt-5">
        <SysCompradorAutocomplete
          v-model="exportacao.codigo_comprador"
          label="Comprador"
          outlined
          hide-details
        />
      </div>

      <div class="mt-5">
        <SysMarcaAutocomplete
          v-if="fornecedor_em_marca"
          v-model="exportacao.codigo_fornecedor"
          label="Fornecedor"
          outlined
          hide-details
          listar_todos_registros_sem_filtros
        />

        <SysFornecedorAutocomplete
          v-else
          v-model="exportacao.codigo_fornecedor"
          label="Fornecedor"
          outlined
          hide-details
        />
      </div>
    </div>

    <template #actions>
      <v-btn
        text
        color="primary"
        @click="exportar"
      >
        ok, exportar
      </v-btn>
    </template>
  </SysDialog>
</template>
<script>
import {computed, ref, watch} from "vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete.vue";

export default {
  name: "ExportacaoApiPedidosSystock",
  components: {
    SysMarcaAutocomplete,
    SysDialog,
    SysFilialGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: Boolean,
    pedido: Object,
    produtos_pedido: Array,
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const fornecedor_em_marca = ref(false);

    const exportacao = ref({
      codigo_filial: '',
      codigo_comprador: '',
      codigo_fornecedor: '',
    });

    const DIALOG_ATIVO_COMPUTED = computed({
      get: () => props.modelValue,
      set: valor => emit('update:modelValue', valor),
    });

    function dialogFechado() {
      DIALOG_ATIVO_COMPUTED.value = false;

      exportacao.value.codigo_filial = '';
      exportacao.value.codigo_comprador = '';
      exportacao.value.codigo_fornecedor = '';
    }

    watch(DIALOG_ATIVO_COMPUTED, () => {
      if (DIALOG_ATIVO_COMPUTED.value) {
        buscarFiltrosExportacao();
      }
    });

    function buscarFiltrosExportacao() {
      api.get(`pedidos-compra/${props.pedido.idpedido}/exportacao/api-pedidos-systock/filtros`)
        .then(resposta => {
          const { filtros } = resposta.data;

          fornecedor_em_marca.value = filtros.fornecedor_em_marca;

          exportacao.value.codigo_filial = filtros.filial || '';

          if (filtros.compradores.length === 1) {
            exportacao.value.codigo_comprador = filtros.compradores[0];
          }

          if (filtros.fornecedores.length === 1 && !fornecedor_em_marca.value) {
            exportacao.value.codigo_fornecedor = filtros.fornecedores[0];
          }
        })
        .catch(logout)
    }

    function exportar() {
      const parametros = {
        codigo_filial: exportacao.value.codigo_filial,
        codigo_comprador: exportacao.value.codigo_comprador,
        codigo_fornecedor: exportacao.value.codigo_fornecedor,
      };

      api.post(`pedidos-compra/${props.pedido.idpedido}/exportacao/api-pedidos-systock`, parametros)
        .then(() => {
          dialogFechado();
        })
        .catch(logout)
    }

    return {
      fornecedor_em_marca,
      DIALOG_ATIVO_COMPUTED,
      exportacao,
      exportar
    }
  }
}
</script>
